// extracted by css-extract-rspack-plugin
export default {"suggestionItem":"suggestion-module__suggestionItem___KYqsa","suggestionText":"suggestion-module__suggestionText___KiVZ5"};